/**
 * CAPTION IT — FAQ accordion
 * One-open-at-a-time, with aria-expanded/aria-controls and smooth height.
 */
(function () {
  'use strict';

  function close(item) {
    const btn = item.querySelector('.ci-faq__question');
    const ans = item.querySelector('.ci-faq__answer');
    item.classList.remove('ci-faq__item--open');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (ans) ans.setAttribute('aria-hidden', 'true');
  }

  function open(item) {
    const btn = item.querySelector('.ci-faq__question');
    const ans = item.querySelector('.ci-faq__answer');
    item.classList.add('ci-faq__item--open');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (ans) ans.setAttribute('aria-hidden', 'false');
  }

  function init() {
    const items = document.querySelectorAll('.ci-faq__item');
    items.forEach((item, i) => {
      const btn = item.querySelector('.ci-faq__question');
      const ans = item.querySelector('.ci-faq__answer');
      if (!btn || !ans) return;

      const id = ans.id || ('ci-faq-a-' + i);
      ans.id = id;
      btn.setAttribute('aria-controls', id);
      btn.setAttribute('aria-expanded', 'false');
      ans.setAttribute('aria-hidden', 'true');

      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('ci-faq__item--open');
        items.forEach(close);
        if (!isOpen) open(item);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
